
import { defineComponent, computed } from 'vue';
import TopMenuCompanySelect from '@/components/TopMenuCompanySelect.vue';
import TopPanelBalance from '@/components/TopPanelBalance.vue';
import TopPanelUserMenu from '@/components/TopPanelUserMenu.vue';
import useCompanySelect from '@/AppCompanySelect';
import useCabinetStore from '@/store/CabinetStore';
import BackToAdminButton from '@/components/BackToAdminButton.vue';
import { OrganizationMode } from '@/gql/graphql';

export default defineComponent({
  components: {
    TopMenuCompanySelect,
    TopPanelBalance,
    TopPanelUserMenu,
    BackToAdminButton,
  },

  setup() {
    const { user, company, breadcrumbs, userRole, isDepartment, isBackToAdminAvailable } = useCabinetStore();
    const { selectedCompanyId, isSelectCompanyAvailable, selectCompany } = useCompanySelect();

    const isSimpleCompany = computed(() =>
      [OrganizationMode.Simple, OrganizationMode.Cards].includes(company.value.mode),
    );

    return {
      user,
      userRole,
      isSelectCompanyAvailable,
      selectedCompanyId,
      selectCompany,
      breadcrumbs,

      isDepartment,
      isTK: computed(() => ['tk', 'azs'].includes(company.value?.type) && isSimpleCompany.value === false),
      isBackToAdminAvailable,
    };
  },
});
